// src/redux/slices/managerEditTrackingEntries.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../config/axiosConfig";
import config from "../../config/api";

const BackendURL = config.backendUrl;

export const replaceWorkEntriesProjectTrack = createAsyncThunk(
  "managerEditTrackingEntries/replaceWorkEntriesProjectTrack",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post(
        `${BackendURL}/workentries/replace-project-track`,
        payload
      );
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const saveUpdateDescriptionTask = createAsyncThunk(
  "managerEditTrackingEntries/saveUpdateDescriptionTask",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post(
        `${BackendURL}/descriptiontask/saveupdate-project-track`,
        payload
      );
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const replaceHardwareProjectTrack = createAsyncThunk(
  "managerEditTrackingEntries/replaceHardwareProjectTrack",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post(
        `${BackendURL}/hardware-description/replace-project-track`,
        payload
      );
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const managerEditTrackingEntriesSlice = createSlice({
  name: "managerEditTrackingEntries",
  initialState: {
    loading: false,
    error: null,
    hardwareResponse: null,
    descriptionTaskResponse: null,
    workEntriesResponse: null,
  },
  reducers: {
    resetTrackingEntriesState: (state) => {
      state.loading = false;
      state.error = null;
      state.hardwareResponse = null;
      state.descriptionTaskResponse = null;
      state.workEntriesResponse = null;
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(replaceHardwareProjectTrack.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(replaceHardwareProjectTrack.fulfilled, (state, action) => {
        state.loading = false;
        state.hardwareResponse = action.payload;
      })
      .addCase(replaceHardwareProjectTrack.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(saveUpdateDescriptionTask.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(saveUpdateDescriptionTask.fulfilled, (state, action) => {
        state.loading = false;
        state.descriptionTaskResponse = action.payload;
      })
      .addCase(saveUpdateDescriptionTask.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(replaceWorkEntriesProjectTrack.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(replaceWorkEntriesProjectTrack.fulfilled, (state, action) => {
        state.loading = false;
        state.workEntriesResponse = action.payload;
      })
      .addCase(replaceWorkEntriesProjectTrack.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetTrackingEntriesState } = managerEditTrackingEntriesSlice.actions;
export default managerEditTrackingEntriesSlice.reducer;
